import { render, staticRenderFns } from "./privacyCollectDetail.vue?vue&type=template&id=14c6f5c5&scoped=true"
import script from "./privacyCollectDetail.vue?vue&type=script&lang=js"
export * from "./privacyCollectDetail.vue?vue&type=script&lang=js"
import style0 from "./privacyCollectDetail.vue?vue&type=style&index=0&id=14c6f5c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c6f5c5",
  null
  
)

export default component.exports